/* istanbul ignore file: this file is mostly jQuery */
'use strict';

customerZone

/**
 * A picker for countries.  This simply prevents us from maintaining the list of supported countries in sixteen places.
 *
 * @param ngModel: model field to bind to.  The value is the country ISO2 code.
 */
.component('countryPicker', {
    bindings: {
        ngModel: '=',
        ngChange: '&',
        ngReadonly: '='
    },
    templateUrl: customerZone.fromBase('components/countrypicker/countrypicker.component.html'),
    controller: [function(){
        var vm = this;
        vm.onChange = function(){
            if (vm.ngChange) vm.ngChange();
        };
        vm.isDisabled = function(){
            return !!vm.ngReadonly;
        };
    }],
    controllerAs: 'vm'
});
